import React from 'react'

import Svg from './svg'


export default function EyeOffIcon({width, height, color, ...props}) {
    color = getComputedStyle(document.documentElement)
        .getPropertyValue(color || '--on-content') || color

    return <Svg width={width || '16px'} height={height || '16px'} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path d="M50,20 C25,20 5,50 5,50 C5,50 25,80 50,80 C75,80 95,50 95,50 C95,50 75,20 50,20 Z M50,68 C38,68 28,60 28,50 C28,40 38,32 50,32 C62,32 72,40 72,50 C72,60 62,68 50,68 Z M50,42 C45,42 41,46 41,50 C41,54 45,58 50,58 C55,58 59,54 59,50 C59,46 55,42 50,42 Z" fill={color || "white"}></path>
            <path d="M15,85 L85,15" stroke={color || "white"} strokeWidth="8" strokeLinecap="round"></path>
        </g>
    </Svg>
}
